// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.candidatos-container {
    padding: 0;
  }

  .candidatos-container h2 {
    margin-bottom: 20px;
    text-align: center;
    color: #f1f1f1;
  }

  .candidatos-filter {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 15px;
    padding: 20px;
    border-radius: 10px;
    margin-bottom: 125px;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  }
  
  .candidatos-filter h2 {
    width: 100%;
    margin: 0 0 10px;
    font-size: 24px;
    color: #ffffff;
  }
  
  .filtro-select,
  .order-select,
  .candidatos-search input {
    padding: 8px 12px;
    font-size: 14px;
    border: 1px solid #ccc;
    border-radius: 6px;
    background-color: #fff;
    transition: border-color 0.3s ease;
  }
  
  .filtro-select:focus,
  .order-select:focus,
  .candidatos-search input:focus {
    border-color: #0077ff;
    outline: none;
  }
  
  .candidatos-search input {
    width: 200px;
  }
  
  .filter-order {
    font-weight: bold;
    margin-right: 5px;
    color: #ffffff;
  }

  .filtro-row {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    align-items: flex-end;
    margin-top: 10px;
  }
  
  .filtro-select,
  .candidatos-search input {
    padding: 8px;
    font-size: 14px;
    border-radius: 5px;
    border: 1px solid #ccc;
  }
  
  .candidatos-search input {
    width: 200px;
  }
  
  .filter-order {
    display: block;
    margin-bottom: 4px;
    font-weight: bold;
    font-size: 13px;
  }
  

  
  
  
  .candidatos-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    row-gap: 90px;
    margin: 0 auto;
    justify-content: center;
  }
  
.candidato-card {
    background: #fff;
    border-radius: 8px;
    padding: 15px;
    display: flex;
    align-items: center;
    gap: 15px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
    width: 300px;
    flex-direction: column;
    position: relative;
}

.candidato-info {
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 10px;
    margin-top: 60px; /* Adjust this value as needed */
}

.candidato-foto {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
    position: absolute;
    top: -60px; /* Adjust this value as needed */
}
  
  .candidato-detalhes {
    text-align: center;
    display: flex;
    flex-direction: column;
  }
  
  .ver-curriculo-btn {
    margin-top: 10px;
    padding: 8px 12px;
    background: #007bff;
    color: #fff;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    transition: 0.3s;
  }
  
  .ver-curriculo-btn:hover {
    background: #0056b3;
  }
  
  /* MODAL */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .modal-content {
    background: white;
    padding: 15px;
    border-radius: 10px;
    width: 60%;
    height: 80%;
    position: relative;
    display: flex;
    flex-direction: column;
  }
  
  .modal-close {
    position: absolute;
    top: 10px;
    right: 15px;
    border: none;
    background: transparent;
    font-size: 20px;
    cursor: pointer;
  }
  
  .curriculo-viewer {
    width: 100%;
    height: 100%;
    border: none;
  }
  


  @media (max-width: 768px) {
    .candidatos-grid {
      flex-direction: column;
      align-items: center;
    }

    .candidato-card {
      width: 90%;
    }

    .candidatos-filter {
      width: 90%;
    }

    .filtro-select {
      width: 100%;
    }

    .modal-content {
      width: 90%;
      height: auto;
    }
  }`, "",{"version":3,"sources":["webpack://./src/styles/AllCandidatos.css"],"names":[],"mappings":"AAAA;IACI,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,uBAAuB;IACvB,yCAAyC;EAC3C;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,cAAc;EAChB;;EAEA;;;IAGE,iBAAiB;IACjB,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,kCAAkC;EACpC;;EAEA;;;IAGE,qBAAqB;IACrB,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;;;;;EAMA;IACE,aAAa;IACb,eAAe;IACf,SAAS;IACT,aAAa;IACb,cAAc;IACd,uBAAuB;EACzB;;AAEF;IACI,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,2CAA2C;IAC3C,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,gBAAgB,EAAE,gCAAgC;AACtD;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,UAAU,EAAE,gCAAgC;AAChD;;EAEE;IACE,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,UAAU;EACV;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;EACd;;;;EAIA;IACE;MACE,sBAAsB;MACtB,mBAAmB;IACrB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,WAAW;IACb;;IAEA;MACE,UAAU;MACV,YAAY;IACd;EACF","sourcesContent":[".candidatos-container {\n    padding: 0;\n  }\n\n  .candidatos-container h2 {\n    margin-bottom: 20px;\n    text-align: center;\n    color: #f1f1f1;\n  }\n\n  .candidatos-filter {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 15px;\n    padding: 20px;\n    border-radius: 10px;\n    margin-bottom: 125px;\n    justify-content: center;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  }\n  \n  .candidatos-filter h2 {\n    width: 100%;\n    margin: 0 0 10px;\n    font-size: 24px;\n    color: #ffffff;\n  }\n  \n  .filtro-select,\n  .order-select,\n  .candidatos-search input {\n    padding: 8px 12px;\n    font-size: 14px;\n    border: 1px solid #ccc;\n    border-radius: 6px;\n    background-color: #fff;\n    transition: border-color 0.3s ease;\n  }\n  \n  .filtro-select:focus,\n  .order-select:focus,\n  .candidatos-search input:focus {\n    border-color: #0077ff;\n    outline: none;\n  }\n  \n  .candidatos-search input {\n    width: 200px;\n  }\n  \n  .filter-order {\n    font-weight: bold;\n    margin-right: 5px;\n    color: #ffffff;\n  }\n\n  .filtro-row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    align-items: flex-end;\n    margin-top: 10px;\n  }\n  \n  .filtro-select,\n  .candidatos-search input {\n    padding: 8px;\n    font-size: 14px;\n    border-radius: 5px;\n    border: 1px solid #ccc;\n  }\n  \n  .candidatos-search input {\n    width: 200px;\n  }\n  \n  .filter-order {\n    display: block;\n    margin-bottom: 4px;\n    font-weight: bold;\n    font-size: 13px;\n  }\n  \n\n  \n  \n  \n  .candidatos-grid {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    row-gap: 90px;\n    margin: 0 auto;\n    justify-content: center;\n  }\n  \n.candidato-card {\n    background: #fff;\n    border-radius: 8px;\n    padding: 15px;\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\n    width: 300px;\n    flex-direction: column;\n    position: relative;\n}\n\n.candidato-info {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    gap: 10px;\n    margin-top: 60px; /* Adjust this value as needed */\n}\n\n.candidato-foto {\n    width: 120px;\n    height: 120px;\n    border-radius: 50%;\n    object-fit: cover;\n    position: absolute;\n    top: -60px; /* Adjust this value as needed */\n}\n  \n  .candidato-detalhes {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .ver-curriculo-btn {\n    margin-top: 10px;\n    padding: 8px 12px;\n    background: #007bff;\n    color: #fff;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    transition: 0.3s;\n  }\n  \n  .ver-curriculo-btn:hover {\n    background: #0056b3;\n  }\n  \n  /* MODAL */\n  .modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.6);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .modal-content {\n    background: white;\n    padding: 15px;\n    border-radius: 10px;\n    width: 60%;\n    height: 80%;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .modal-close {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    border: none;\n    background: transparent;\n    font-size: 20px;\n    cursor: pointer;\n  }\n  \n  .curriculo-viewer {\n    width: 100%;\n    height: 100%;\n    border: none;\n  }\n  \n\n\n  @media (max-width: 768px) {\n    .candidatos-grid {\n      flex-direction: column;\n      align-items: center;\n    }\n\n    .candidato-card {\n      width: 90%;\n    }\n\n    .candidatos-filter {\n      width: 90%;\n    }\n\n    .filtro-select {\n      width: 100%;\n    }\n\n    .modal-content {\n      width: 90%;\n      height: auto;\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
